import React, { memo } from 'react';

import settings from '~/settings';
import { ngettext, t } from '~/helpers/localization';

import EventCountdown from '~/UIKit/EventCountdown/EventCountdown';

import styles from './PatrolsDialogHeader.module.scss';

type IProps = {
  hideDialog: () => void;
};

const PatrolsDialogHeader: React.FC<IProps> = ({ hideDialog }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.back} onClick={hideDialog}>
          {t('Назад')}
        </button>
        <div className={styles.title}>{t('Clan Patrols')}</div>
        <button className={styles.close} onClick={hideDialog} />
      </div>
      <EventCountdown
        className={styles.countdown}
        date={(settings.patrols?.eventFinishesAt || 0) * 1000}
        showEndDate={true}
        additionalText={ngettext('Renewal period: %(number)s day.', 'Renewal period: %(number)s day.', 1, {
          number: 1,
        })}
      />
    </div>
  );
};

export default memo(PatrolsDialogHeader);
